(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      // CUSTOM (29.10.2026, Lisa: Kopfbereich fehlte oben, nachdem die Seite gesprungen war): Dawn nahm die Lage des
      // Kopfbereichs aus dem sichtbaren Teil im Bildschirm. Laedt die Seite mitten im Text (Safari stellt die
      // Scroll-Position wieder her), ist der Kopf nicht sichtbar und die Werte stehen auf 0. Jetzt die Lage im Dokument.
      const messen = () => {
        const r = this.header.getBoundingClientRect();
        const versteckt = this.header.classList.contains('shopify-section-header-hidden') || this.header.classList.contains('shopify-section-header-sticky');
        if (versteckt && this.headerBounds.bottom) return;
        this.headerBounds = { top: Math.max(0, r.top + window.scrollY), bottom: r.bottom + window.scrollY };
      };
      messen();
      window.addEventListener('resize', messen);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      } else if (scrollTop < this.currentScrollTop) {
        // CUSTOM (29.10.2026, Lisa: oben fehlte das Menue): beim Hochscrollen oder Hochspringen in den Bereich des
        // Kopfes ganz einblenden. Bei Dawn blieb er dort versteckt, bis man ganz oben war.
        requestAnimationFrame(this.reveal.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      // CUSTOM (Okt. 2026): Suche nur schliessen, wenn sie offen ist. Dawns close() nimmt sonst bei jedem
      // Ausblenden des Kopfbereichs die Scroll-Sperre der Seite weg (body.overflow-hidden) - auch wenn
      // gerade der Warenkorb offen ist. Dann scrollte beim Scrollen im Warenkorb die Seite dahinter mit.
      if (this.searchModal && this.searchModal.isOpen()) this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jh-erig-zubehoer"] && !Shopify.designMode) return;
  try {
    
  // CUSTOM: E-Rig Zubehoer-Karten - bei Variantenwahl Varianten-ID im Formular, Preis und Streichpreis der Karte anpassen
  document.addEventListener('change', function (event) {
    var auswahl = event.target.closest && event.target.closest('.jhe-dazu__auswahl');
    if (!auswahl) return;
    var karte = auswahl.closest('.jhe-dazu__karte');
    var option = auswahl.options[auswahl.selectedIndex];
    if (!karte || !option) return;
    var preis = karte.querySelector('[data-jhe-preis]');
    var alt = karte.querySelector('[data-jhe-alt]');
    var form = document.getElementById(auswahl.dataset.form);
    var feld = form && form.querySelector('[name=id]');
    if (feld) feld.value = option.value;
    if (preis) preis.textContent = option.dataset.preis;
    if (alt) {
      alt.textContent = option.dataset.alt || '';
      alt.hidden = !option.dataset.alt;
    }
  });

  } catch(e) { console.error(e); }
})();
})();
